/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IAwardKitSkuDataState } from "Interfaces/SiteContent/IAwardKitSkuDataState";

import { IGetAwardKitSkuSuccess, IGetAwardKitSkuFailure } from "./AwardKitSkuAction";
import { AWARD_KIT_SKU_LOAD_SUCCESS, AWARD_KIT_SKU_LOAD_FAILURE } from "./AwardKitSkuActionTypes";

const initialState: IAwardKitSkuDataState = {
  awardKitSkuOptionList: [],
  awardKitSkuLoadError: "",
};

/**
 * Updates state of fetch awardkit sku success.
 * @param {IAwardKitSkuDataState} state The awardkit sku state.
 * @param {IGetAwardKitSkuSuccess} action The awardkit sku action success.
 * @returns {IAwardKitSkuDataState} New awardkit sku state.
 */
const applyLoadAwardKitSku = (
  state: IAwardKitSkuDataState,
  action: IGetAwardKitSkuSuccess
): IAwardKitSkuDataState => ({
  ...state,
  awardKitSkuOptionList: action.awardKitSku,
});

/**
 * Updates state of fetch awardkit sku failure.
 * @param {IAwardKitSkuDataState} state The awardkit sku state.
 * @param {IGetAwardKitSkuFailure} action The awardkit sku action failure.
 * @returns {IAwardKitSkuDataState} New awardkit sku state.
 */
const applyLoadAwardKitSkuFail = (
  state: IAwardKitSkuDataState,
  action: IGetAwardKitSkuFailure
): IAwardKitSkuDataState => ({
  ...state,
  awardKitSkuLoadError: action.awardKitSkuLoadError,
});

/**
 * Reducer function for MVP Award Kit Benefit component.
 * @param {IAwardKitSkuDataState} state The sku state.
 * @param {AwardKitSkuActionTypes} action The sku type.
 * @returns {IAwardKitSkuDataState} The sku state.
 */
function awardKitSkuReducer(
  state: IAwardKitSkuDataState = initialState,
  action
): IAwardKitSkuDataState {
  switch (action.type) {
    case AWARD_KIT_SKU_LOAD_SUCCESS:
      return applyLoadAwardKitSku(state, action);
    case AWARD_KIT_SKU_LOAD_FAILURE:
      return applyLoadAwardKitSkuFail(state, action);
    default:
      return state;
  }
}

export default awardKitSkuReducer;
